(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  function updateFooterNewsletterText(root = document) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.section-footer__newsletter-block').forEach((newsletter) => {
      const placeholder = newsletter.dataset.newsletterPlaceholder || '';
      const buttonLabel = newsletter.dataset.newsletterButtonLabel || '';

      const emailInput = newsletter.querySelector('input[type="email"]');
      if (emailInput && placeholder) {
        emailInput.setAttribute('placeholder', placeholder);
        emailInput.setAttribute('aria-label', placeholder);

        newsletter.querySelectorAll('label[for]').forEach((label) => {
          if (label.htmlFor === emailInput.id) {
            label.textContent = placeholder;
          }
        });
      }

      const submitControl = newsletter.querySelector(
        'button[type="submit"], input[type="submit"]'
      );

      if (!submitControl || !buttonLabel) return;

      submitControl.setAttribute('aria-label', buttonLabel);
      submitControl.setAttribute('title', buttonLabel);

      if (submitControl.tagName === 'INPUT') {
        submitControl.value = buttonLabel;
        return;
      }

      const directTextNode = Array.from(submitControl.childNodes).find(
        (node) =>
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim().length > 0
      );

      if (directTextNode) {
        directTextNode.textContent = buttonLabel;
        return;
      }

      const textElement = Array.from(
        submitControl.querySelectorAll(
          '[data-button-text], .button__text, .newsletter-signup__button-text, span'
        )
      ).find(
        (element) =>
          element.textContent.trim().length > 0 &&
          !element.querySelector('svg')
      );

      if (textElement) {
        textElement.textContent = buttonLabel;
      } else {
        submitControl.appendChild(document.createTextNode(buttonLabel));
      }
    });
  }

  updateFooterNewsletterText();

  document.addEventListener('DOMContentLoaded', () => {
    updateFooterNewsletterText();
  });

  document.addEventListener('shopify:section:load', (event) => {
    updateFooterNewsletterText(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.shopify-section');
    updateFooterNewsletterText(section || document);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (function () {
    function loadProductRecommendations(section) {
      if (!section || !section.dataset.url) {
        return;
      }

      if (section.dataset.recommendationsLoading === 'true') {
        return;
      }

      section.dataset.recommendationsLoading = 'true';

      var request = new XMLHttpRequest();

      request.open('GET', section.dataset.url);

      request.onload = function () {
        section.dataset.recommendationsLoading = 'false';

        if (request.status < 200 || request.status >= 300) {
          return;
        }

        var responseContainer = document.createElement('div');
        responseContainer.innerHTML = request.responseText;

        var loadedSection = responseContainer.querySelector(
          '.related-products'
        );

        if (!loadedSection) {
          return;
        }

        section.innerHTML = loadedSection.innerHTML;
      };

      request.onerror = function () {
        section.dataset.recommendationsLoading = 'false';
      };

      request.send();
    }

    function loadAllRelatedProductSections(context) {
      var sections = context.querySelectorAll(
        '.related-products'
      );

      sections.forEach(function (section) {
        loadProductRecommendations(section);
      });
    }

    loadAllRelatedProductSections(document);

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        var relatedProductsSection = null;

        if (
          event.target.classList &&
          event.target.classList.contains('related-products')
        ) {
          relatedProductsSection = event.target;
        } else if (event.target.querySelector) {
          relatedProductsSection = event.target.querySelector(
            '.related-products'
          );
        }

        if (relatedProductsSection) {
          loadProductRecommendations(relatedProductsSection);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
